import { render } from "./SimpleNotesToolbar.vue?vue&type=template&id=6429afd6&scoped=true"
import script from "./SimpleNotesToolbar.vue?vue&type=script&lang=js"
export * from "./SimpleNotesToolbar.vue?vue&type=script&lang=js"

import "./SimpleNotesToolbar.vue?vue&type=style&index=0&id=6429afd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6429afd6"]])

export default __exports__